import { autoPlacement, flip, offset, ReferenceType, useClick, useDismiss, useFloating, useInteractions } from "@floating-ui/react-dom-interactions";
import { useState } from "react";
import { BlockPicker } from "react-color";

let defaultColors = [ "f44336", "e91e63", "9c27b0", "673ab7", "3f51b5", "2196f3", "03a9f4", "00bcd4", "009688", "4caf50", "8bc34a", "cddc39", "ffeb3b", "ffc107", "ff9800", "ff5722", "795548", "9e9e9e", "607d8b"];

interface Props {
  initialColor?: string;
  onColorChange: (color: string) => void;
  strategy? : 'fixed' | 'absolute';
  children : (reference : (node : ReferenceType | null)=>void, referenceProp : Record<string, unknown> )=>JSX.Element;
}

const ColorPicker = ({ initialColor = "2196f3", onColorChange, strategy : _strategy = 'absolute', children } : Props) => {
  const [color, setColor] = useState<string>(initialColor);
  const [open, setOpen] = useState(false);

  const {x, y, reference, floating, strategy, context} = useFloating({
      open,
      onOpenChange: setOpen,
      strategy : _strategy,
      middleware: [autoPlacement(), offset(10)]
  });
  const {getReferenceProps, getFloatingProps} = useInteractions([
    useClick(context),
    useDismiss(context),
  ]);

  const handleColorChange = (newColor: string) => {
    setColor(newColor);
    onColorChange(newColor);
  };

  return (
    <>
      {children(reference, getReferenceProps())}
      {( open && 
        <div
            ref={floating}
            className="z-10"
            style={{
                position: strategy,
                top: y ?? 0,
                left: x ?? 0,
            }}
            {...getFloatingProps()}
        >
            <div className=" text-white flex flex-col shadow-around">
                <BlockPicker
                  color={`${color}`}
                  colors={defaultColors.map((c)=>`#${c}`)}
                  triangle="hide"
                  onChange={(c) => handleColorChange(`${c.hex}`.replace("#", ""))}
                />
            </div>
        </div>)}
    </>
  );
};

export default ColorPicker;